import { makeRequest } from 'lib/api';
import { objectToUrlParams } from 'modules/core/utils/url';

export interface ClientActivityRequest {
  page?: number,
  size?: number,
}

export const activityController = {
  getClientActivity: (clientId: string, params: ClientActivityRequest = {}): Promise<any> => {
    return makeRequest('get', `/v1/clients/${ clientId }/activity?${ objectToUrlParams(params) }`);
  },
};
